<template>
  <div>
    <b-modal
      ref="editCustomerModal"
      lazy
      hide-footer
      size="xl"
      content-class="topcard cust-model"
      @hide="redirectCustomer"
      @close="redirectCustomer"
    >
      <template #modal-title>
        Customer Profile
      </template>
      <EditCustomer
        :customerId="customerId"
        v-if="customerId"
        @customer-saved="customerSaved"
      />
    </b-modal>
    <b-form-group
      class="mb-0"
      style="z-index: 100;"
      v-click-outside="closeSearch"
    >
      <b-input-group
        class="input-group-alternative input-group-merge"
        style="z-index: 100"
      >
        <div class="input-group-prepend" style="z-index: 100">
          <span class="input-group-text"><i class="fas fa-search"></i></span>
        </div>

        <b-form-input
          placeholder="Search or add customer"
          type="text"
          v-model="searchTerm"
          ref="searchInput"
          @focus="searchFocus"
          style="z-index: 100; width:400px"
          v-debounce:300ms="search"
          autocomplete="off"
        >
        </b-form-input>

        <div class="autocomplete-items" v-show="isSearch">
          <div class="autocomplete-body">
            <div class="yolo">
              <div
                class="text-muted small"
                v-show="state == 'ready' && searchTerm == ''"
              >
                Search by name, email, or customer number.
              </div>

              <div
                v-show="
                  state == 'results.loading' || state == 'results.complete'
                "
              >
                <div class="addSearchTerm text-center">
                  <b-button class="primary btn-block" @click="newCustomer"
                    >New Customer {{ searchTerm }}</b-button
                  >
                  <hr />
                </div>

                <div v-show="state == 'results.loading'" class="resultsLoading">
                  <loading-svg :width="40" :height="40"></loading-svg>
                </div>

                <div
                  v-show="
                    state == 'results.complete' && searchResults.length == 0
                  "
                >
                  <div class="light-alert mb-0">
                    <i class="fa-solid fa-people-simple"></i>No customers found.
                  </div>
                </div>

                <div v-if="state == 'results.complete'">
                  <div
                    v-for="(item, index) in searchResults"
                    v-bind:key="index"
                    class="searchResultRow"
                    @click="selectedSearchItem(item)"
                  >
                    <customer-search-item :item="item"></customer-search-item>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="hasRole('BETA')">
              <div class="pip">
                <h4>Completed Appointments</h4>
              </div>
              <div
                v-show="pipState == 'results.loading'"
                class="resultsLoading"
              >
                <loading-svg :width="40" :height="40"></loading-svg>
              </div>

              <div
                class="text-muted noPatientsFound"
                v-if="pipState == 'results.complete' && pipResults.length == 0"
              >
                <div class="light-alert">
                  <i class="fa-solid fa-calendar-xmark"></i>No completed
                  appointments requiring payment.
                </div>
              </div>

              <div v-if="pipState == 'results.complete'">
                <div
                  v-for="(item, index) in pipResults"
                  v-bind:key="index"
                  class="searchResultRow"
                  @click="selectedSearchItem(item)"
                >
                  <customer-search-item :item="item"> </customer-search-item>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-input-group>
    </b-form-group>
  </div>
</template>

<script>
import CustomerSearchItem from "./CustomerSearchItem.vue";
import EditCustomer from "@/views/Components/Customer/EditCustomer.vue";
export default {
  name: "customer-search",
  components: { "customer-search-item": CustomerSearchItem, EditCustomer },
  inject: ["hasRole"],
  data() {
    return {
      customerId: null,

      searchTerm: "",
      isSearch: false,
      searchResults: [],
      pipResults: [],
      state: "ready",
      pipState: "ready",
    };
  },
  props: {
    routerName: {
      type: String,
      default: "CustomerIndex", // default|light
      description: "Where to navigate on selection",
    },
  },
  created() {},
  methods: {
    customerSaved() {
      this.$refs.editCustomerModal.hide();
      this.redirectCustomer();
    },
    redirectCustomer() {
      location.href = "/#/customer/" + this.customerId + "?state=tabs";
    },
    async newCustomer() {
      var self = this;

      let firstName = null;
      let lastName = null;

      if (this.searchTerm.indexOf(" ")) {
        firstName = this.searchTerm.split(" ")[0];
        lastName = this.searchTerm.split(" ")[1];
      }

      var r = await this.$client.post("/api/customer/addCustomer", {
        firstName: firstName,
        lastName: lastName,
      });

      this.customerId = r.data.value.id;

      this.$refs.editCustomerModal.show();

      this.closeSearch();
    },
    search() {
      var self = this;
      this.customerId = null;

      if (self.searchTerm == "") {
        self.state = "ready";
        self.searchResults = [];
        return;
      }

      self.isSearch = true;
      self.state = "results.loading";

      self.$client
        .get("/api/customer/searchCustomer?name=" + self.searchTerm, {
          noProgress: true,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            var r = response.data.value;

            self.searchResults = r;
            self.state = "results.complete";
            return;
          }
        });
    },

    getPip() {
      var self = this;

      self.pipState = "results.loading";

      self.$client
        .get("/api/patient/patientsInPractice", {
          noProgress: true,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            var r = response.data.value;

            self.pipResults = r;
            self.pipState = "results.complete";
            return;
          }
        });
    },
    closeSearch() {
      this.searchTerm = "";
      console.log("Closing...");
      this.isSearch = false;
    },
    async selectedSearchItem(item) {
      var self = this;
      location.href = "/#/customer/" + item.id;
      self.closeSearch();
    },
    searchFocus() {
      var self = this;
      console.log("Search focus..");
      self.$refs.searchInput.select();
      self.isSearch = true;
      self.state = "ready";
      //self.getPip();
    },
  },
};
</script>

<style scoped>
.inputSearch {
  background-color: gray;
}
.autocomplete-head {
  float: right;
}
.resultsLoading {
  padding: 5px 0;
}
.autocomplete-body {
  margin: 30px 15px 15px 15px;
}
.searchResultRow {
  padding: 10px 15px;
  margin-left: -15px;
  margin-right: -15px;
}
.searchResultRow:hover {
  background-color: #f6f9fc !important;
  cursor: pointer;
  border-radius: 4px;
}
.rowSelect {
  background-color: #f6f9fc !important;
}

.yolo {
  min-height: 50px;
}

.pip {
  border-top: solid 1px #e0e0e0;
  padding-top: 10px;
  margin-top: 25px;
  margin-bottom: 10px;
}

.addSearchTerm {
  border-top: solid 1px #e0e0e0;
}

.cust-modal .card-header {
  font-weight: 600;
  background: #fff;
}

.note-body {
  background: #e9ecef;
  border-radius: 4px;
  padding: 15px;
}

.note-footer {
  font-size: 0.8em;
  padding: 10px 10px 20px 10px;
}

.note:last-child .note-footer {
  padding-bottom: 0px;
}

.triangle {
  margin-left: 20px;
  width: 0;
  border-top: 15px solid #e9ecef;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  cursor: pointer;
}
</style>
